












import { Vue, Component, Prop } from "vue-property-decorator";
import ReviewGroupsComponent from "./ReviewGroups.vue";
import StartDateComponent from "./StartDate.vue";
import InfoComponent from "./Info.vue";
import CreditsComponent from "./Credits.vue";
import GithubReferenceComponent from "./GithubReference.vue";

@Component({
    components: {
        "review-groups": ReviewGroupsComponent,
        "start-date": StartDateComponent,
        "info": InfoComponent,
        "credits": CreditsComponent,
        "github-reference": GithubReferenceComponent,
    }
})
export default class Root extends Vue {
    selectedDate = new Date();

    mounted() {
        if(localStorage.startDate) {
            this.selectedDate = new Date(localStorage.startDate);
        }
    }
    
    startDateChanged(newValue: Date) {
        this.selectedDate = newValue;
        localStorage.startDate = newValue.toISOString();
    }
};
